import React from 'react'
import { WorkspaceTabBar, WorkspaceTabBarPropTypes } from 'ui-components'

const View = (props) => {
  const {
    canUpdateWorkspaceSettings,
    totalMaps,
    totalCollections,
    totalMembers,
    loading,
    currentTab,
    onTabChange
  } = props

  return (
    <WorkspaceTabBar
      canUpdateWorkspaceSettings={canUpdateWorkspaceSettings}
      totalMaps={totalMaps}
      totalCollections={totalCollections}
      totalMembers={totalMembers}
      loading={loading}
      currentTab={currentTab}
      onTabChange={onTabChange}
    />
  )
}

View.propTypes = WorkspaceTabBarPropTypes

export { View }
